export enum DqStage {
    preDesign = "preDesign",
    postDesign = "postDesign",
}
